import React from 'react';

const AboutVisionMission: React.FC = () => (
  <>
    {/* Mission Row - Solid Blue */}
    <section className="bg-[#2980b9] py-24 md:py-32">
      <div className="container-main grid md:grid-cols-12 gap-8 md:gap-16 items-start">
        <div className="md:col-span-4 lg:col-span-3">
          <h2 className="text-white font-bold text-xl tracking-widest uppercase">Our Mission</h2>
        </div>
        <div className="md:col-span-8 lg:col-span-7">
          <p className="text-white text-lg md:text-xl font-light leading-relaxed mb-6">
            To grow with the medical supplies industry, creating a name by giving customers quality CE-certified, FDA-approved products at competitive prices across Africa.
          </p>
          <p className="text-white/90 text-sm md:text-base font-light leading-relaxed">
            We are the most efficient surgical equipment, dental equipment, electrosurgical equipment, diagnostics kits and laboratory equipment suppliers in Zimbabwe. Manlab Medicals Incorporated exports to any country within Africa.
          </p>
        </div>
      </div>
    </section>

    {/* Vision Row - Image Background */}
    <section className="relative py-24 md:py-32">
      {/* Pexels image: Medical professionals/laboratory */}
      <img 
        src="https://images.pexels.com/photos/3845126/pexels-photo-3845126.jpeg?auto=compress&cs=tinysrgb&w=1920&q=80" 
        alt="Medical Vision" 
        className="absolute inset-0 w-full h-full object-cover object-center" 
      />
      <div className="absolute inset-0 bg-black/60" /> {/* Dark overlay */}
      
      <div className="container-main relative z-10 grid md:grid-cols-12 gap-8 md:gap-16 items-start">
        <div className="md:col-span-4 lg:col-span-3">
          <h2 className="text-white font-bold text-xl tracking-widest uppercase">Our Vision</h2>
        </div>
        <div className="md:col-span-8 lg:col-span-7">
          <p className="text-white text-lg md:text-xl font-light leading-relaxed mb-6">
            To be the most trusted and efficient medical supplies company in sub-Saharan Africa.
          </p>
          <p className="text-white/80 text-sm md:text-base font-light leading-relaxed">
            Known for quality, competitive pricing, and exceptional customer service. Our aim is to grow with the medical supplies and mining industry, maintaining discipline and precision.
          </p>
        </div>
      </div>
    </section>
  </>
);

export default AboutVisionMission;
